import {
	Component,
	Input,
	OnInit,
	AfterViewInit,
	OnChanges,
	OnDestroy,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import axios from "axios";
import * as L from "leaflet";
import { CentrosViewModel } from "src/app/_core/models/centros/centro.model";
import { DebounceService } from "src/app/_core/providers/debounce.service";

@Component({
	selector: "app-centro-map-card",
	templateUrl: "./centro-map-card.component.html",
	styleUrls: ["./centro-map-card.component.scss"],
})
export class CentroMapCardComponent
	implements OnInit, OnChanges, OnDestroy, AfterViewInit
{
	@Input() centro: CentrosViewModel;
	@Input() detailFormGroup: FormGroup;

	// Maps
	public options: any;
	public map: L.Map;
	public layers: any = [];
	public center: L.LatLng;
	public fitBounds: L.LatLngBounds;
	public layersControl;
	public zoom: number;
	mapInitialized = false;
	centroDetailsForm: FormGroup;

	constructor(private readonly _debounceService: DebounceService) {}

	// Events
	ngOnInit(): void {
		if (!this.mapInitialized) {
			this.initializeMaps();
		}
	}

	ngOnChanges(): void {
		if (this.mapInitialized) {
			this.initializeMaps();
		}
	}

	ngOnDestroy(): void {
		if (this.mapInitialized) {
			this.map.remove();
			this.mapInitialized = false;
		}
	}

	ngAfterViewInit() {
		this.initializeMaps();
	}

	initializeMaps(): void {
		if (!this.mapInitialized && document.getElementById("map")) {
			if (this.centro.id) {
				const lat = parseFloat(this.centro.latitud);
				const lng = parseFloat(this.centro.longitud);
				this.center = new L.LatLng(lat, lng);
				this.zoom = 13;
				this.fitBounds = new L.LatLngBounds(this.center, this.center);
			} else {
				const defaultLat = 0;
				const defaultLng = 0;
				this.center = new L.LatLng(defaultLat, defaultLng);
				this.zoom = 1;
				this.fitBounds = new L.LatLngBounds(this.center, this.center);
			}

			const redIcon = L.icon({
				shadowUrl: "assets/icons/marker-shadow.png",
				iconSize: [28, 38],
				shadowSize: [28, 38],
				iconAnchor: [17, 38],
				shadowAnchor: [10, 38],
				popupAnchor: [-3, -76],
				iconUrl: "assets/icons/marker-icon.png",
				//iconUrl: 'https://th.bing.com/th/id/R.89186bdbc92213089a2ca2f38b55a040?rik=tKvWrJjv1lfseg&riu=http%3a%2f%2fwww.clipartbest.com%2fcliparts%2facq%2fLAa%2facqLAa9Ki.png&ehk=9L0a3CvQLNFrjB%2btFPzKg2rmY%2bC9rE9gqEZI4dhMe%2fQ%3d&risl=&pid=ImgRaw&r=0'
				//iconUrl: ''
				//url('/assets/images/services/alt.jpg')
			});

			this.map = L.map("map").setView(this.center, this.zoom);

			L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
				attribution: "© OpenStreetMap contributors",
			}).addTo(this.map);

			this.mapInitialized = true;

			if (this.centro.id) {
				const marker = L.marker([this.center.lat, this.center.lng], {
					draggable: true,
					icon: redIcon,
				})
					.addTo(this.map)
					.bindPopup(this.centro.descripcion)
					.openPopup();

				marker.dragging.enable();

				const debouncedReverseGeocode = this._debounceService.debounce(
					async (event) => {
						const newLatLng = event.target.getLatLng();
						this.centro.latitud = newLatLng.lat.toFixed(6);
						this.centro.longitud = newLatLng.lng.toFixed(6);

						let ciudadFromResponse = "";

						try {
							const response = await axios.get(
								`https://nominatim.openstreetmap.org/reverse?format=json&lat=${newLatLng.lat}&lon=${newLatLng.lng}`
							);

							this.detailFormGroup
								.get("latitud")
								.setValue(response.data.lat);
							this.detailFormGroup
								.get("longitud")
								.setValue(response.data.lon);

							ciudadFromResponse =
								response.data.address.city ||
								response.data.address.town ||
								response.data.address.village ||
								response.data.address.suburb;
						} catch (error) {
							console.error(
								"Error fetching reverse geocoding data:",
								error
							);
						}

						if (ciudadFromResponse !== undefined) {
							this.centro.ciudad = ciudadFromResponse || "N/A";
							this.detailFormGroup
								.get("ciudad")
								.setValue(this.centro.ciudad);
						} else {
							this.detailFormGroup.get("ciudad").setValue("N/A");
						}
					},
					500
				);

				marker.on("dragend", (event) => debouncedReverseGeocode(event));
			} else {
				const marker = L.marker(this.center, {
					draggable: true,
				}).addTo(this.map);

				marker.dragging.enable();

				const debouncedReverseGeocode = this._debounceService.debounce(
					async (event) => {
						const newLatLng = event.target.getLatLng();
						this.centro.latitud = newLatLng.lat.toFixed(6);
						this.centro.longitud = newLatLng.lng.toFixed(6);

						// this.detailFormGroup.get("latitud").setValue(this.centro.latitud);
						// this.detailFormGroup.get("longitud").setValue(this.centro.longitud);

						let ciudadFromResponse = "";

						try {
							const response = await axios.get(
								`https://nominatim.openstreetmap.org/reverse?format=json&lat=${newLatLng.lat}&lon=${newLatLng.lng}`
							);

							this.detailFormGroup
								.get("latitud")
								.setValue(response.data.lat);
							this.detailFormGroup
								.get("longitud")
								.setValue(response.data.lon);

							ciudadFromResponse =
								response.data.address.city ||
								response.data.address.town ||
								response.data.address.village ||
								response.data.address.suburb;
						} catch (error) {
							console.error(
								"Error fetching reverse geocoding data:",
								error
							);
						}

						if (ciudadFromResponse !== undefined) {
							this.centro.ciudad = ciudadFromResponse || "N/A";
							this.detailFormGroup
								.get("ciudad")
								.setValue(this.centro.ciudad);
						} else {
							this.detailFormGroup.get("ciudad").setValue("N/A");
						}
					},
					500
				);

				marker.on("dragend", (event) => debouncedReverseGeocode(event));
			}
		}
	}
}
